export var MatchUrgency;
(function (MatchUrgency) {
    MatchUrgency["Now"] = "now";
    MatchUrgency["Today"] = "today";
    MatchUrgency["Week"] = "week";
    MatchUrgency["FewWeeks"] = "few_weeks";
    MatchUrgency["Unsure"] = "unsure";
})(MatchUrgency || (MatchUrgency = {}));
export var MatchFrequency;
(function (MatchFrequency) {
    MatchFrequency["Once"] = "once";
    MatchFrequency["Twice"] = "twice";
    MatchFrequency["Daily"] = "daily";
    MatchFrequency["Weekly"] = "weekly";
    MatchFrequency["Unsure"] = "unsure";
})(MatchFrequency || (MatchFrequency = {}));
export var MatchReason;
(function (MatchReason) {
    MatchReason["Struggle"] = "struggle";
    MatchReason["Advance"] = "advance";
    MatchReason["Exams"] = "test_prep";
    MatchReason["Personal"] = "personal";
    MatchReason["Other"] = "other";
})(MatchReason || (MatchReason = {}));
export var MatchLevel;
(function (MatchLevel) {
    MatchLevel["Elementary"] = "elementary";
    MatchLevel["Middle"] = "middle";
    MatchLevel["High"] = "high";
    MatchLevel["College"] = "college";
    MatchLevel["Other"] = "other";
})(MatchLevel || (MatchLevel = {}));
export var MatchType;
(function (MatchType) {
    MatchType["Regular"] = "regular";
    MatchType["Instant"] = "instant";
})(MatchType || (MatchType = {}));
export var MatchStatus;
(function (MatchStatus) {
    MatchStatus["Abandoned"] = "abandoned";
    MatchStatus["Active"] = "active";
    MatchStatus["Canceled"] = "canceled";
    MatchStatus["Resolved"] = "resolved";
    MatchStatus["Pending"] = "pending";
    MatchStatus["Idle"] = "idle";
})(MatchStatus || (MatchStatus = {}));
export var MatchAction;
(function (MatchAction) {
    MatchAction["Accept"] = "accept";
    MatchAction["Resolve"] = "resolve";
    MatchAction["Cancel"] = "cancel";
    MatchAction["Withdraw"] = "withdraw";
    MatchAction["Resubmit"] = "resubmit";
    MatchAction["Transfer"] = "transfer";
})(MatchAction || (MatchAction = {}));
export var MatchParticipantStatus;
(function (MatchParticipantStatus) {
    MatchParticipantStatus["Active"] = "active";
    MatchParticipantStatus["Inactive"] = "inactive";
})(MatchParticipantStatus || (MatchParticipantStatus = {}));
export var MatchAssignmentType;
(function (MatchAssignmentType) {
    MatchAssignmentType["Direct"] = "direct";
    MatchAssignmentType["Queue"] = "queue";
    MatchAssignmentType["Manual"] = "manual";
})(MatchAssignmentType || (MatchAssignmentType = {}));
export var MatchFlagType;
(function (MatchFlagType) {
    MatchFlagType["Student"] = "student";
    MatchFlagType["Positive"] = "positive";
    MatchFlagType["Safety"] = "safety";
})(MatchFlagType || (MatchFlagType = {}));
export var MatchFlagStatus;
(function (MatchFlagStatus) {
    MatchFlagStatus["Active"] = "active";
    MatchFlagStatus["Resolved"] = "resolved";
})(MatchFlagStatus || (MatchFlagStatus = {}));
//# sourceMappingURL=match.js.map